import { render, staticRenderFns } from "./Newsknows.vue?vue&type=template&id=09612b12&scoped=true&"
import script from "./Newsknows.vue?vue&type=script&lang=js&"
export * from "./Newsknows.vue?vue&type=script&lang=js&"
import style0 from "./Newsknows.vue?vue&type=style&index=0&id=09612b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09612b12",
  null
  
)

export default component.exports